module.exports = __webpack_public_path__ + "static/img/1.a3c3c6a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/about/eng/1.png
// module id = xXnD
// module chunks = 0